module.exports = __webpack_public_path__ + "static/media/bankserv.ef75b780.jpeg";